import React from "react";
import ESocialContainer from "./_/container";
import "./styles.scss";

const ESocial = (props) => <ESocialContainer {...props} />;

export default ESocial;
